import type { LigonierAuthResponseDTO } from './LigonierAuthResponseDTO.js'
import type { SilentAuthResponse } from '../../utils/auth.js'

/**
 * Translates the raw auth API response into the domain model.
 * Any future field renames on the API side are isolated to this file.
 *
 * Note: field names currently match 1:1 — this is intentional isolation, not
 * redundancy. If the API renames a field, only this file needs to change.
 */
export function normalizeLigonierAuthResponse(dto: LigonierAuthResponseDTO): SilentAuthResponse {
  return {
    authenticated: dto.authenticated,
    authenticatedForPII: dto.authenticatedForPII,
    accessToken: dto.accessToken,
    isMinistryPartner: dto.isMinistryPartner,
    email: dto.email,
    id: dto.id,
    ligId: dto.ligId,
    firstName: dto.firstName,
    lastName: dto.lastName,
    partnerAccess: dto.partnerAccess,
  }
}
